import axios from "axios";

axios.defaults.timeout = 3000;

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        if(response.status == 200) {
            return response;
        } else if(response.status == 404) {
            console.log('404')
        } else if(response.status == 500) {
            console.log('内部服务器错误');
        }
    },
    function (err) {
        return Promise.reject(err);
    }
);

// const apiUrl = 'http://5s2dxx.natappfree.cc'
// const apiUrl = ''
const apiUrl = 'https://ms.fuxinsz.com'
// 导入 get
export async function apiGet(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(apiUrl + url, {
            params: params || '',
            headers:{"token": localStorage.getItem("token") || '' }
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    });
}
export async function apiGets(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params || '',
            headers:{"token": localStorage.getItem("token") || '' }
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    });
}

// 导入 post
export async function apiPost(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: apiUrl + url,
            headers:{"Authorization": sessionStorage.getItem("author") || "" },
            data: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    });
}

// 导入 delete
export async function apiDelete(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: apiUrl + url,
            headers:{"Authorization": sessionStorage.getItem("author") || "" },
            data: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    });
}


// WEBPACK FOOTER //
// ./src/api.js